import { StyledDivider } from "./styles/StyledDivider";

const Divider = () => <StyledDivider />;

export default Divider;
